let csrf = window._csrf || window.csrf
let waitForLogin
let isLoading = []
import toaster from "./toaster-store.js"
import { writable } from 'svelte/store'

export let netcount = writable(0) // number of network requests
export let loggingIn = writable(false)

const updateCSRF = async ()=>{
  await fetch("/")
  let csrfcookie = document.cookie.match(/_csrf=([^ ;]+)/)
  if(csrfcookie && csrfcookie.length > 0){
    window._csrf = window.csrf = csrf = csrfcookie[1]  
    // console.log("new csrf",csrf)
    return csrf
  }
}

const showError = (res,json)=>{
  let title = res.status < 500 ? "Sorry..." : "Error!"
  let type = res.status < 500 ? "warning" : "danger"
  let message = json.message || "Unknown Error"
  toaster.add({type,title,message})
}

export const load = async ({url,showErrors=true})=>{
  netcount.update(n => n + 1)
  let res,json
  try{
    res = await fetch(url)
    json = await res.json()
    // await updateCSRF() // causes excess fetches
  }catch(e){
    throw new Error(e.message)
  }finally{
    netcount.update(n => n - 1)
  }
  if (res.ok){
    return json
  }
  if (res.status == 401 && waitForLogin){
    await needsLogin() // show login
    return load({url}) // try again
  }
  if(url!="/duocms/api/login" && showErrors) showError(res,json)
  throw new Error(json.message); 
}

export const save = async ({url,data, method,retry=3,showErrors=true})=>{
  if (!method){
    method = data.id ? "PUT" : "POST"
    url += data.id ? `/${data.id}` : ""
  }
  if(!csrf){
    csrf = window._csrf || window.csrf
  }
  let res = await fetch(url ,{
    headers: {'content-type': 'application/json','X-CSRF-Token':csrf},
    credentials: 'same-origin',
    method: method,
    body: JSON.stringify(data)
  })
  let json = await res.json();
  if(res.status == 403 && json.message.match(/csrf/i) && retry > 0){
      await updateCSRF() //updated csrf and try again?
      retry--
      return save({url,data,method,retry})
  }
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await needsLogin() // show login
    return save({url,data,method}) // try again
  }
  if(showErrors) showError(res,json)
  throw new Error(json.message);
}

export const remove = async ({url,retry=3,showErrors=true})=>{
  if(!csrf){
    csrf = window._csrf || window.csrf
  }
  let res = await fetch(url,{
    headers: new Headers({'content-type': 'application/json','X-CSRF-Token':csrf}),
    credentials: 'same-origin',
    method: "DELETE"
  })
  let json = await res.json();
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await needsLogin() // show login
    return load(url) // try again
  }
  if(res.status == 403 && json.message.match(/csrf/i) && retry > 0){
    await updateCSRF() //updated csrf and try again?
    retry--
    return remove({url,retry,showErrors})
  }
  if(showErrors) showError(res,json)
  throw new Error(json.message); 
}

export const upload = async ({url,file,path,name,retry=3})=>{
  let formData = new FormData()
  let res,json
  if(csrf) formData.append("_csrf", csrf)
  formData.append("path", path)
  formData.append("name", name ? name : file.name)
  formData.append('file', file)
  netcount.update(n => n + 1)
  try{
    res = await fetch(url, { method: 'POST', body: formData })
    try{
      json = await res.json()
    }catch(err){
      //invalid json, write our own errors here
      if(res.status==400) json = {message:"Sorry, that file could not be uploaded there."}
      if(res.status==401) json = {message:"Please login"}
      if(res.status==403) json = {message:"Sorry, you don't have permission."}
      if(res.status==413) json = {message:"The file you are uploading is too large"}
    }
  }catch(e){
    throw new Error(e.message)
  }finally{
    netcount.update(n => n - 1)
  }
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await needsLogin() // show login
    return upload({url,file,path,name}) // try again
  }
  if(res.status == 403 && json.message.match(/csrf/i) && retry > 0){
    await updateCSRF() //updated csrf and try again?
    retry--
    if(url.match(/_csrf/)) url = url.replace(/csrf=[^&]+/,`csrf=${window.csrf}`)
    return upload({url,file,path,name,retry})
  }
  if(url!="/duocms/api/login") showError(res,json)
  throw new Error(json.message); 
}

// allows data to be sent as multi-part form for uploading multiple files + data in one go, used in forum
export const formSave = async({url,data,method,retry=3})=>{
  if (!method){
    method = data.id ? "PUT" : "POST"
    url += data.id ? `/${data.id}` : ""
  }
  let formData = new FormData()
  let res,json
  if(window.csrf) formData.append("_csrf", window.csrf)
  Object.keys(data).forEach(key =>{
    if(key=="files"){
      for(let file of data.files){
        console.log("appending",file.file)
        formData.append("file",file.file)
      }
    }else if(data[key]!=null){// prevent null values being saved
      formData.append(key,data[key])
    }
  })
  netcount.update(n => n + 1)
  try{
    // add csrf to url
    let href = new URL(url,window.location)
    if(csrf) href.searchParams.set("_csrf",csrf)
    res = await fetch(href.toString(), { method: method, body: formData })
    json = await res.json()
  }catch(e){
    console.log(e)
    throw new Error(e.message)
  }finally{
    netcount.update(n => n - 1)
  }
  if (res.ok) return {data:json.data}
  if (res.status == 401 && waitForLogin){
    await needsLogin() // show login
    retry--
    return formSave({url,data,method,retry:retry}) // try again
  }
  if(res.status == 403 && json.message.match(/csrf/i) && retry > 0){
    await updateCSRF() //updated csrf and try again?
    retry--
    if(url.match(/_csrf/)) url = url.replace(/csrf=[^&]+/,`csrf=${window.csrf}`)
    return formSave({url,data,method,retry:retry}) // try again
  }
  if(url!="/duocms/api/login") showError(res,json)
  throw new Error(json.message); 
}

async function needsLogin(){
  loggingIn.update(val => true)
  await waitForLogin()
  loggingIn.update(val => false)
}

export const registerLogin = (cback)=> waitForLogin = cback

export default {load,save,remove,registerLogin,netcount,upload,loggingIn,formSave}